import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1E2962'
        },
        secondary: {
            main: '#BCCCE3'
        },
        contrastThreshold: 3,
        tonalOffset: 0.2
    },
    typography: {
        fontFamily: `"Poppins", "Helvetica", "Arial", sans-serif`,
        body1: {
            fontFamily: '"Comfortaa", "Arial", sans-serif'
        }
    }
});

export default theme;
